export const formatNumber = (value) => {
  return Intl.NumberFormat("ru-RU").format(value);
};

export const getMimeType = (filename) => {
  const extension = filename?.split('.').pop().toLowerCase();
  
  const mimeTypes = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    bmp: 'image/bmp',
    tiff: 'image/tiff',
    heic: 'image/heic',
    heif: 'image/heif',
  };

  return mimeTypes[extension] || 'application/pdf';
};